import isequal from 'lodash.isequal';
import EdapActions from '../../actions/edapActions';

let lastPriceSummaryEventParams = null;

function logPriceSummaryEvent(store, priceSummaryEventParams) {
    if (isequal(priceSummaryEventParams, lastPriceSummaryEventParams)) {
        // don't log a price summary event if nothing has changed since the last time we logged an event
        // (react re-rendering might cause this method to be called multiple times for the same price summary)
        return;
    }

    // keep track of the last payload that was logged
    lastPriceSummaryEventParams = priceSummaryEventParams;

    // make a copy of the original payload since the EDAP library will actually munge some of the payload values
    // (converting numbers to strings, etc...)
    priceSummaryEventParams = Object.assign({}, priceSummaryEventParams);
    store.dispatch(EdapActions.triggerEdapEvent('price.summary.display', priceSummaryEventParams));
}

export default logPriceSummaryEvent;
export {
    logPriceSummaryEvent
};
